import { get, del, post, put } from 'aws-amplify/api';
import { Document } from '../models/document.model';
import { CreateDocumentRequest, CreateDocumentRequestSchema } from '../models/createDocument.model';
import { replaceNullsWithEmpty } from '../utils/utils';

export const createDocument = async (createDocument: CreateDocumentRequest) => {
  const createDocumentBody = mapToRequest(createDocument);
  const response = await post({
    apiName: 'documents',
    path: '/documents',
    options: { body: createDocumentBody },
  }).response;

  const json = (await response.body.json()) as any;
  return json;
};

export const getDocuments = async (filters: {
  title?: string;
  limit?: number;
  lastKey?: string;
}): Promise<{ items: Document[]; lastKey: string }> => {
  const limit = filters.limit ?? 100;
  const lastKey = filters.lastKey ?? '';
  const title = filters.title ? encodeURIComponent(filters.title) : '';
  const response = await get({
    apiName: 'documents',
    path: `/documents?title=${title}&limit=${limit}&lastKey=${lastKey}`,
  }).response;
  const json = (await response.body.json()) as any;
  return {
    items: json.items.map((a: any) => mapFromResponse(a)),
    lastKey: json.lastKey,
  };
};

export const getDocument = async (documentId: string): Promise<Document> => {
  const response = await get({ apiName: 'documents', path: `/documents/${documentId}` }).response;
  const json = (await response.body.json()) as any;
  return mapFromResponse(json);
};

export const updateDocument = async (document: Document): Promise<void> => {
  // For updates, we send the full document object (excluding id which is in the path)
  const { id, ...updateData } = document;
  await put({
    apiName: 'documents',
    path: `/documents/${document.id}`,
    options: { body: updateData },
  }).response;
};

export const deleteDocument = async (documentId: string): Promise<void> => {
  await del({ apiName: 'documents', path: `/documents/${documentId}` }).response;
};

const mapFromResponse = (doc: any): Document => {
  const res: Document = {
    ...doc,
  };
  return replaceNullsWithEmpty(res);
};

const mapToRequest = (document: CreateDocumentRequest): any => {
  const resParse = CreateDocumentRequestSchema.safeParse(document);
  if (resParse.success) {
    return resParse.data;
  }

  throw new Error('Validation error');
};

